import { Box } from "@mui/material";
import { AddressElement } from "@stripe/react-stripe-js";
import { CheckoutContext } from "contexts/Checkout";
import { useContext } from "react";
import { CustomEvent } from "schemas/functions";

interface Props {
  handleChange: (event: CustomEvent) => void;
}

const BillingAddressForm = ({ handleChange }: Props) => {
  const { customer } = useContext(CheckoutContext);

  return (
    <Box sx={{ mb: 2 }}>
      <AddressElement
        options={{
          mode: "billing",
          autocomplete: {
            mode: "google_maps_api",
            apiKey: process.env.REACT_APP_GOOGLE_MAPS_JS_KEY || "",
          },
          defaultValues: {
            name: customer?.name,
            address: {
              country: customer?.address?.country,
              postal_code: customer?.address?.postal_code,
              line1: customer?.address?.line1,
              line2: customer?.address?.line2,
              city: customer?.address?.city,
              state: customer?.address?.state,
            },
          },
        }}
        onChange={handleChange}
      />
    </Box>
  );
};

export default BillingAddressForm;
